// extracted by mini-css-extract-plugin
module.exports = {"base":"FormInfoBox-module-base","text":"FormInfoBox-module-text","withOutRichText":"FormInfoBox-module-with-out-rich-text"};